import { BlogArticleFrontMatter } from '@prishapolicy/markdown';
import React from 'react';

export const ArticleContext = React.createContext<BlogArticleFrontMatter | null>(null);
export const useArticleContext = () => React.useContext(ArticleContext);
